export default {
  search: 'جستجو',
  loading: '...',
  searchUsers: 'کاربرها',
  searchDirects: 'مکالمه‌ها',
  noReceivedMessages: 'بدون پیام',
};
